<template>
  <div class="row">
    <div class="chart-wrapper">
      <label for="" class="hidden">{{ indicatorSelected }}</label>
      <label for="" class="hidden">{{ stateSelected }}</label>
      <div class="chart-title">
        <div class="col-md-12 bg-primary" style="max-height: 40px">
          <div class="col-md-12 text-center car_table_header">
            <!-- <h5 class=""> -->
            <label class="table-label">
              {{ indicatorSelected }}
              <span style="font-weight: normal"
                >and related indicators (with year of latest values)
                {{ $store.state.CAR.stateNameLookUpTable[selectedState] }}
              </span>
            </label>
            <!-- </h5> -->
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <div
        id="scrollTable"
        class="chart-stage col-xs-12"
        style="overflow-x: auto; width: 100%"
      >
        <!-- <button
          id="scrollLeft"
          class="material-button-raised table-scroll scroll-left"
          v-tooltip.left="'Scroll left'"
          @click="scrollPage('scrollLeft')"
        >
          <v-icon dark large color="black">keyboard_arrow_left</v-icon>
        </button>
        <button
          id="scrollRight"
          class="material-button-raised table-scroll scroll-right"
          v-tooltip.left="'Scroll right'"
          @click="scrollPage('scrollRight')"
        >
          <v-icon dark large color="black">keyboard_arrow_right</v-icon>
        </button> -->
        <table class="my_custom_table" id="source_table">
          <thead>
            <tr class="custom_header">
              <td></td>
              <td :colspan="routineCounter" v-if="routineCounter > 0">
                Routine
              </td>
              <td :colspan="surveyCounter" v-if="surveyCounter > 0">Surveys</td>
              <td :colspan="estimatesCounter" v-if="estimatesCounter > 0">
                Estimates
              </td>
              <!-- <td v-for="(sourceClass,index) in sourceClass" :key="index" v-html="sourceClass" :class="sourceClass===''?'':'custom_header'"></td> -->
            </tr>
            <tr>
              <td style="">
                <span class="refresh_sources_icon">
                  INDICATORS
                  <v-icon
                    @click="refreshSources"
                    v-tooltip.top="'Show all sources'"
                    color="white"
                    >refresh</v-icon
                  >
                </span>
              </td>
              <td
                @click="tableSourceClicked(source.name)"
                :id="source.name"
                class="table_sources"
                v-for="(source, index) in dataSourceUncertainty"
                :key="index"
              >
                <!-- <div class="table_fixing" data-step="4" data-intro='<b>Select Data Source </b><p>You can change currently viewed data source by clicking on any of the sources</p>'></div> -->
                <!-- <span class="source_name" v-tooltip.top="sourceFullName[source.name]" >{{source.name}}</span> -->
                <span
                  class="source_name"
                  v-if="source.name == 'NHMIS-DHIS2'"
                  v-tooltip.top="sourceFullName[source.name]"
                  data-step="4"
                  data-intro="<b>Select Data Source </b><p>Click on any of these data sources to change the currently visualized data source</p>"
                  >{{ source.name }}</span
                >
                <span
                  class="source_name"
                  v-else-if="source.name == 'NHMIS-DHIS2 (monthly)'"
                  v-tooltip.top="sourceFullName[source.name]"
                  data-step="4"
                  data-intro="<b>Select Data Source </b><p>Click on any of these data sources to change the currently visualized data source</p>"
                  >NHMIS-DHIS2<br />(monthly)</span
                >
                <span
                  class="source_name"
                  v-else
                  v-tooltip.top="sourceFullName[source.name]"
                  >{{ source.name }}</span
                >

                <svg
                  v-if="source.name == 'NHMIS-DHIS2 (monthly)'"
                  style="width: 13px; height: 13px"
                  viewBox="0 0 24 24"
                  v-tooltip.right="'Click to see source definition'"
                  @click.prevent.stop="viewSourceMetadata('NHMIS')"
                >
                  <path
                    d="M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
                  />
                </svg>

                <svg
                  v-else
                  style="width: 13px; height: 13px"
                  viewBox="0 0 24 24"
                  v-tooltip.right="'Click to see source definition'"
                  @click.prevent.stop="viewSourceMetadata(source.name)"
                >
                  <path
                    d="M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
                  />
                </svg>

                <span
                  v-if="isUncertaintyAvailable[source.name] === true"
                  v-tooltip.top="'See confidence range'"
                  class="web-features"
                  style="top: 0"
                >
                  <b-switch
                    v-model="source.uncertainty"
                    @click.native.prevent.stop="
                      plotUncertainty(source.uncertainty, source.name, index)
                    "
                    type="is-success"
                  >
                  </b-switch>
                </span>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr
              style="max-height: 80px"
              v-for="(indicator, count) in indicatorRelativeValuese"
              :key="count + Math.random()"
            >
              <td
                style="word-wrap: break-word; text-align: left; cursor: default"
              >
                <div v-show="count !== 1 && count !== 0">
                  <div style="display: flex">
                    <!-- <span style="display: none">{{index}}</span> -->
                    <span
                      class="table_info_icon"
                      style="background: #41918e; margin-right: 4px"
                      v-tooltip.right="'Click to see metadata definition'"
                      @click="viewMetadata(indicator[0][0])"
                    >
                      <svg
                        style="width: 20px; height: 20px"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#FFF"
                          d="M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
                        />
                      </svg>
                    </span>
                    <span class="table-multiselect">
                      <multi-select
                        data-step="5"
                        data-intro="<b>Change Related Indicator</b><p>Click here to select your preferred related indicator from the drop-down menu</p>"
                        :ref="'relative' + count - 1"
                        v-model="selectIndicatorRelative[count - 1]"
                        :options="optionIndicators"
                        group-values="indicators"
                        group-label="programArea"
                        :group-collapsible="collapsible"
                        @open="openedMultiselect"
                        @search-change="multiselectSearch"
                        @close="closedMultiselect(indicator[0][0], count - 1)"
                        :group-select="false"
                        :group-collapsible-expanded="false"
                        :allow-empty="false"
                        :show-labels="false"
                        :placeholder="multiselectPlaceholderM(count - 1)"
                        track-by="name"
                        label="name"
                      >
                        <span slot="noResult">
                          Oops! No elements found. Change the search query.
                        </span>
                        <!-- <span
                              class="arrow"
                              slot="caret"
                              slot-scope="{ toggle }"
                              @mousedown.prevent.stop="toggle"
                            >
                            </span> -->
                      </multi-select>
                    </span>
                  </div>
                  <span
                    class="display-factor"
                    style="color: black"
                    v-html="'(' + displayFactor[count] + ')'"
                  ></span>
                </div>
                <div v-show="count === 1">{{ indicator[0][0] }}</div>
                <div v-show="count === 0">
                  <span
                    class="table_info_icon1"
                    style="background: #fff; margin-right: 8px"
                    data-v-step="2"
                    v-tooltip.right="'Click to see metadata definition'"
                    @click="viewMetadata(indicator[0][0])"
                  >
                    <svg style="width: 20px" viewBox="0 0 24 24">
                      <path
                        fill="#41918E"
                        d="M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
                      />
                    </svg>
                  </span>
                  <span @click="viewMetadata(indicator[0][0])">{{
                    indicator[0][0]
                  }}</span
                  ><br />
                  <span
                    class="display-factor"
                    style="color: white"
                    v-html="'(' + displayFactor[count] + ')'"
                  ></span>
                </div>
              </td>
              <!-- <td v-for="(item,counter) in indicator" :key="counter" v-html="item"></td> -->
              <!-- <pre>{{ indicator[1] }}</pre> -->
              <td
                v-for="(item, counter) in indicator[1]"
                :key="counter"
                v-html="item"
              ></td>
            </tr>

            <tr id="nhmis-hidden-bar" v-if="showToggle">
              <td
                style="
                  background-color: #367574;
                  margin-bottom: #367574;
                  max-height: 45px;
                "
                :colspan="spanning + 2"
              >
                <div class="row numden">
                  <div class="numden1">
                    <!-- <multi-select style="transform: scale(0.8); min-width: fit-content;" open-direction="top"  v-model="ndSelected" :options="nd"
                  :hide-selected="false" :searchable="false" :allow-empty="false" :show-labels="false"
                  placeholder=""></multi-select> -->
                    <div
                      class="py-2"
                      style="
                        color: #fff;
                        font-weight: bold;
                        letter-spacing: 0;
                        font-size: 14px;
                      "
                    >
                      {{ ndSelected }}
                    </div>
                  </div>
                  <div
                    class="numden2 py-2 border"
                    style="
                      background-color: #fff;
                      border-radius: 4px;
                      padding-bottom: 5px;
                    "
                  >
                    <div class="col-md-6 col-xs-6 col-sm-6 mr-3 text-wrap">
                      <strong>Numerator</strong> : {{ numerator }}:
                      {{ thousandSeperator(numValue) }}
                    </div>
                    <div class="col-md-5 col-xs-5 col-sm-5 ml-3 text-wrap">
                      <strong>Denominator</strong> : {{ denominator }}:
                      {{ thousandSeperator(denValue) }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>

            <!-- <tr v-for="(indicator,index,count) in indicatorRelativeValues" :key="count"> -->
            <tr
              v-for="(indicator, count) in indicatorRelativeValues"
              :key="count"
            >
              <td
                style="word-wrap: break-word; text-align: left; cursor: default"
              >
                <div v-show="count == 1 || count == 2">
                  <div style="display: flex">
                    <!-- <span style="display: none">{{index}}</span> -->
                    <span
                      class="table_info_icon"
                      style="background: #41918e; margin-right: 4px"
                      v-tooltip.right="'Click to see metadata definition'"
                      @click="viewMetadata(indicator[0][0])"
                    >
                      <svg
                        style="width: 20px; height: 20px"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#FFF"
                          d="M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
                        />
                      </svg>
                    </span>
                    <span class="table-multiselect">
                      <multi-select
                        data-step="5"
                        data-intro="<b>Change Related Indicator</b><p>Click here to select your preferred related indicator from the drop-down menu</p>"
                        :ref="'relative' + count"
                        v-model="selectIndicatorRelative[count - 1]"
                        :options="optionIndicators"
                        group-values="indicators"
                        group-label="programArea"
                        :group-collapsible="collapsible"
                        @open="openedMultiselect"
                        @search-change="multiselectSearch"
                        @close="closedMultiselect(indicator[0][0], count - 1)"
                        :group-select="false"
                        :group-collapsible-expanded="false"
                        :allow-empty="false"
                        :show-labels="false"
                        :placeholder="multiselectPlaceholderM(count - 1)"
                        track-by="name"
                        label="name"
                      >
                        <span slot="noResult">
                          Oops! No elements found. Change the search query.
                        </span>
                        <!-- <span
                              class="arrow"
                              slot="caret"
                              slot-scope="{ toggle }"
                              @mousedown.prevent.stop="toggle"
                            >
                            </span> -->
                      </multi-select>
                    </span>
                  </div>
                  <span
                    class="display-factor"
                    style="color: black"
                    v-html="'(' + displayFactor[count + 1] + ')'"
                  ></span>
                </div>
                <div v-show="count === 0">{{ indicator[0][0] }}</div>
                <!-- <div v-show="count !== 0">
                  <span
                    class="table_info_icon1"
                    style="background: #FFF;margin-right:8px;"
                    data-v-step="2"
                    v-tooltip.right="'Click to see metadata definition'"
                    @click="viewMetadata(indicator[0][0])"
                  >
                    <svg style="width:20px;" viewBox="0 0 24 24">
                      <path
                        fill="#41918E"
                        d="M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
                      />
                    </svg>
                  </span>
                  <span @click="viewMetadata(indicator[0][0])">{{
                    indicator[0][0]
                  }}</span
                  ><br />
                  <span
                    class="display-factor"
                    style="color: white;"
                    v-html="'(' + displayFactor[count] + ')'"
                  ></span>
                </div> -->
              </td>
              <!-- <td v-for="(item,counter) in indicator" :key="counter" v-html="item"></td> -->
              <td
                v-for="(item, counter) in indicator[1]"
                :key="counter"
                v-html="item"
              ></td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-modal :active.sync="isComponentModalActive" has-modal-card>
        <form action="">
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title">
                <b>INDICATOR: </b> {{ this.indicatorMetaDataToShow }}
              </p>
            </header>
            <section class="modal-card-body">
              <div class="tabs is-boxed is-right">
                <!-- On click change class of li to is-active and populate data. -->
                <ul>
                  <li
                    v-for="i in availableSources"
                    :key="i"
                    :value="i"
                    :class="{ 'is-active': i == isActive }"
                    @click="dataSourceClicked(i)"
                  >
                    <a>
                      <span>{{ i }}</span>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="panel panel-info">
                <div class="panel-heading">INDICATOR NAME</div>
                <div class="panel-body">
                  <span>{{ this.sourceIndicatorInfo.name }}</span>
                </div>
              </div>
              <div class="panel panel-info">
                <div class="panel-heading">INDICATOR SHORT NAME</div>
                <div class="panel-body">
                  <span> {{ this.sourceIndicatorInfo.shortName }}</span>
                </div>
              </div>
              <div class="panel panel-info">
                <div class="panel-heading">INDICATOR DEFINITION</div>
                <div class="panel-body">
                  <span> {{ this.sourceIndicatorInfo.definition }}</span>
                </div>
              </div>
              <div class="panel panel-info">
                <div class="panel-heading">MEASUREMENT</div>
                <div class="panel-body">
                  <div style="margin: 10px">
                    <b>Numerator: </b
                    ><span>{{ this.sourceIndicatorInfo.numerator }}</span>
                  </div>
                  <div style="margin: 10px">
                    <b>Denominator: </b
                    ><span>{{ this.sourceIndicatorInfo.denominator }}</span>
                  </div>
                </div>
              </div>
              <div class="panel panel-info">
                <div class="panel-heading">MULTIPLIER FACTOR</div>
                <div class="panel-body">
                  <span>{{ this.sourceIndicatorInfo.multiplier }}</span>
                </div>
              </div>
              <div class="panel panel-info">
                <div class="panel-heading">FREQUENCY</div>
                <div class="panel-body">
                  <span>{{ this.sourceIndicatorInfo.frequency }}</span>
                </div>
              </div>
              <div class="panel panel-info">
                <div class="panel-heading">TYPE OF INDICATOR</div>
                <div class="panel-body">
                  <span> {{ this.sourceIndicatorInfo.type }}</span>
                </div>
              </div>
              <div class="panel panel-info">
                <div class="panel-heading">Level of Data Available</div>
                <div class="panel-body">
                  <span
                    >National
                    <v-icon :color="this.dataAvailable.National"
                      >check_circle</v-icon
                    ></span
                  >
                  <span
                    >Geopolitical Zone
                    <v-icon :color="this.dataAvailable.Zonal"
                      >check_circle</v-icon
                    ></span
                  >
                  <span
                    >State Level
                    <v-icon :color="this.dataAvailable.State"
                      >check_circle</v-icon
                    ></span
                  >
                  <span
                    >Senatorial Zone
                    <v-icon :color="this.dataAvailable.Senatorial"
                      >check_circle</v-icon
                    ></span
                  >
                  <span
                    >Local Govt Area
                    <v-icon :color="this.dataAvailable.LGA"
                      >check_circle</v-icon
                    ></span
                  >
                </div>
              </div>
            </section>
            <footer class="modal-card-foot">
              <button
                class="button is-danger pull-right"
                type="button"
                @click="isComponentModalActive = false"
              >
                CLOSE
              </button>
            </footer>
          </div>
        </form>
      </b-modal>
    </div>
    <div v-if="isSourceMetaModalActive">
      <table-modal
        :src="datasingle"
        :sourceMetaData="datafull"
        @switchOff="clearModal"
      ></table-modal>
    </div>
  </div>
</template>

<script>
// Import statements
import { indDB } from "../../../../main";
import str_limit from "@/assets/js-on/strlimit";
import MultiSelect from "@/assets/js-on/vue-multiselect";
import TableModal from "../components/mt.vue";
import { eventBus } from "../../../../main.js";

export default {
  props: [
    "appData",
    "uncertaintyData",
    "meta_data",
    "indicatorMetaData",
    "sourceMetaData",
    "selectedIndicator56",
  ],
  components: {
    MultiSelect,
    TableModal,
  },
  data() {
    return {
      lsNdStateData: JSON.parse(this.$ls.get("nd_state_data")),
      lsNdLgaData: JSON.parse(this.$ls.get("nd_lga_data")),
      ndSelected: "NHMIS:2020",
      //selectedSource: "NHMIS",
      selectedYear: "2020",
      ndYear: [],
      ndStateData: [],
      showToggle: false,
      ndOptionsArray: [],
      ndOptions: [],
      datasingle: "",
      datafull: [],
      denominator: "",
      numerator: "",
      numValue: "",
      denValue: "",
      selectedIndicator: "Skilled attendance at delivery or birth",
      NhmisMonthlySelectedState: "Nigeria",
      selectedState: "National",
      availableSources: [],
      sourceClass: [],
      isActive: false,
      sourceList: [
        "MICS",
        "NDHS",
        "NARHS",
        "NMIS",
        "NNHS",
        "NHMIS-DHIS2",
        "World Bank",
        "IHME",
        "WHO-GHO",
        "WUENIC",
        "PCCS",
        "UNAIDS",
        "NHSPSS",
        "NHA",
        "KDGHS",
        "NAIIS",
      ],
      sourceFullName: {
        "NHMIS-DHIS2": "National Health Management Information System",
        "NHMIS-DHIS2 (monthly)":
          "National Health Management Information System Monthly",
        NDHS: "Nigeria Demographic and Health Survey",
        NHSPSS: "National HIV Sero-Prevalence Sentinel Survey",
        MICS: "Multiple Indicator Cluster Survey",
        NNHS: "National Nutrition and Health Survey",
        NMIS: "Nigeria Malaria Indicator Survey",
        NHA: "National Health Accounts",
        NARHS: "National HIV & AIDS and Reproductive Health Survey",
        KSGHR: "Kaduna State General Household Survey",
        PCCS: "Measles Post Campaign Coverage Survey",
        "WHO-GHO": "WHO - Global Health Observatory",
        "World Bank": "World Bank",
        IHME: "Institute for Health Metrics and Evaluation",
        WUENIC: "WHO and UNICEF Estimates of National Immunization Coverage",
        UNAIDS: "The Joint United Nations Programme on HIV and AIDS",
        NAIIS: "Nigeria HIV/AIDS Indicator and Impact Survey",
        KDGHS: "Kaduna General Household Survey",
      },
      dataSourceClass: {
        "NHMIS-DHIS2": "Routine",
        NDHS: "Surveys",
        NHSPSS: "Surveys",
        KDGHS: "Surveys",
        NHA: "Surveys",
        NAIIS: "Surveys",
        MICS: "Surveys",
        NNHS: "Surveys",
        NMIS: "Surveys",
        NARHS: "Surveys",
        KSGHR: "Surveys",
        PCCS: "Surveys",
        "UN IGME": "Estimate",
        "WHO-GHO": "Estimates",
        "World Bank": "Estimates",
        IHME: "Estimates",
        WUENIC: "Estimates",
        UNAIDS: "Estimates",
      },
      dataSourceUncertainty: {},
      indicatorRelativeValues: {},
      indicatorRelativeValuese: [],
      surveyCounter: 0,
      indicatorMetaDataToShow: "",
      lsData: JSON.parse(this.$ls.get("car_other_dataset")),
      spanning: 0,
      estimatesCounter: 0,
      routineCounter: 0,
      sourceIndicatorInfo: {},
      dataAvailable: {
        National: "grey",
        State: "grey",
        Senatorial: "grey",
        Zonal: "grey",
        LGA: "grey",
      },
      selectedTargetGroup: "",
      selectedSampledHouseholdData: "",
      indicatorInfo: [],
      dataSourceName: "",
      selectedDescription: "",
      sourceIndicatorInfo: {},
      isComponentModalActive: false,
      isUncertaintyAvailable: {},
      optionIndicators: [],
      indicatorRelatives: [],
      selectIndicatorRelative: [
        {
          name: "ANC Coverage (at least 1 visit)",
        },
        {
          name: "Postnatal care coverage (mother)",
        },
      ],
      multiselectPlaceholder: ["Search1", "Search2"],
      collapsible: true,
      indicatorRelativesObject: {},
      isSourceMetaModalActive: false,
      sourceInfo: {},
      displayFactor: [],
      nhmisMonthlyData: [],
    };
  },
  methods: {
    getDS() {
      const result = [];
      const DSMeta = JSON.parse(this.$ls.get("source_meta_dataset"));
      const DSMeta2 = DSMeta.slice(1);
      DSMeta2.map((el) => {
        result.push([`${el[0]} : ${el[1]}`]);
      });
      // get the sourcelist data
      const ds = DSMeta2.map((el) => el[0]);
      this.sourceList = ds;

      // get the datasource fullnames data
      const dsFullNames = result.map((el) => {
        return el
          .map((keyVal) => {
            return keyVal.split(":").map((_) => _.trim());
          })
          .reduce((accumulator, currentValue) => {
            accumulator[currentValue[0]] = currentValue[1];
            return accumulator;
          }, {});
      });

      this.sourceFullName = Object.assign({}, ...dsFullNames);

      // get classifications
      const results = [];
      DSMeta2.map((el) => {
        results.push([`${el[0]} : ${el[8]}`]);
      });

      const reOrderedDs = results.filter((el) => {
        if (el[0].split(":")[0].trim() !== "NHMIS-DHIS2") {
          return el;
        }
      });
      reOrderedDs.unshift(["NHMIS-DHIS2 : Routine"]);

      const dsClassification = reOrderedDs.map((el) => {
        return el
          .map((keyVal) => {
            return keyVal.split(":").map((_) => _.trim());
          })
          .reduce((accumulator, currentValue) => {
            accumulator[currentValue[0]] = currentValue[1];
            return accumulator;
          }, {});
      });

      this.dataSourceClass = Object.assign({}, ...dsClassification);
    },
    async getIdb() {
      var data;
      await indDB
        .transaction("rw", indDB.stateNumDen, function* () {
          data = yield indDB.stateNumDen.toArray();
        })
        .catch(function (err) {
          // Catch any error event or exception and log it:
          //console.error(err.stack || err);
        });
      //console.log(data)
      return data;
    },
    thousandSeperator(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getNdMetaData() {
      if (this.indicatorMetaData) {
        let result = this.indicatorMetaData.filter(
          (val) =>
            val[0] == this.selectedSource && val[1] == this.selectedIndicator
        );
        return result;
      }
    },
    getIndicatorSourceIndex(val) {
      //let list = this.lsNdStateData[0]
      //console.log(list)
      let check = this.selectedIndicator56 + " -> " + this.selectedSource;
      return val[0].indexOf(check);
    },
    async ndSelectedOption() {
      // this.lsNdStateData = await this.getIdb();

      // let indicator, source, location;
      if (this.lsNdStateData !== null) {
        let obj1 = this.lsNdStateData.filter(
          (val) => val[0] == this.selectedYear
        );
        //console.log(this.selectedYear)
        // console.log(obj1);
        this.ndStateData = obj1;

        //this.$store.dispatch('storeNdStateData',  this.ndStateData);

        let obj = obj1.filter((val) => val[1] == this.selectedState);
        //console.log(obj)
        let index = this.getIndicatorSourceIndex(this.lsNdStateData);
        //console.log(index)
        if (index < 0) {
          this.numerator = "Unavailable";
          this.denominator = "Unavailable";
          this.numValue = "";
          this.denValue = "";
        }
        let ndValue = obj[0][index];
        if (ndValue !== undefined) {
          ndValue = ndValue.split("#");
          //console.log(obj1)
          let ndMeta = this.getNdMetaData();
          //console.log(ndMeta[0][3])

          if (obj.length !== 0 && ndMeta[0] !== undefined) {
            this.numerator = ndMeta[0][3];
            this.denominator = ndMeta[0][4];
            this.numValue = ndValue[0];
            this.denValue = ndValue[1];
          } else {
            this.numerator = "Unavailable";
            this.denominator = "Unavailable";
            this.numValue = "";
            this.denValue = "";
          }
        }
      }
      //console.log(obj);
      this.ndSelected = `${this.selectedSource}` + ":" + `${this.selectedYear}`;
    },
    clearModal() {
      this.isSourceMetaModalActive = false;
    },
    scrollPage(elem) {
      let scrollElem = document.getElementById("scrollTable");
      let scrollLeft = document.getElementById("scrollLeft");
      let getWidth = scrollElem.scrollWidth;

      if (elem == "scrollRight") {
        scrollElem.scrollLeft += 40;

        scrollLeft.style.display = "block";
      }
      if (elem == "scrollLeft") {
        scrollElem.scrollLeft -= 40;

        if (scrollElem.scrollLeft == 0) {
          scrollLeft.style.display = "none";
        }
      }
    },
    refreshSources() {
      //Remove background color for all sources
      let tableSources = document.querySelectorAll(".table_sources");
      tableSources.forEach((sources, index) => {
        // if (sources.style.background === "rgb(65, 145, 142)") {
        if (
          sources.style.background === "rgb(54, 117, 116)" ||
          sources.style.background === "rgb(65, 145, 142)"
        ) {
          sources.childNodes[2].style.background = "#41918E";
          sources.childNodes[2].style.fill = "#DDD";
          sources.style.background = "";
          sources.style.color = "#333";
          sources.style.borderBottomColor = "#DDD";

          //Remove Background from NHMIS after refresh
          source_table.rows[2].cells[1].style.background = "#41918E";
          source_table.rows[2].cells[1].style.borderBottomColor = "#DDD";
          source_table.rows[2].cells[1].style.borderTopColor = "#DDD";
        }
      });

      this.$store.dispatch("storeSourceClicked", this.availableSources);
      this.showToggle = false;
    },
    /**
     * This method get the availble sources with data based in the indicator and state selected
     */
    getAvailbleSourcesByIndicator(indicator, state) {
      // Variable declarations
      let routineCounter = 0,
        estimatesCounter = 0,
        surveyCounter = 0,
        data = this.appData.slice(0),
        stateData,
        indicatorNames = data[0],
        indicatorIndex = 0,
        sources = [],
        sourceClass = [],
        sourceData = {},
        sourceObject = {};

      this.dataSourceUncertainty = [];

      indicatorNames.map((indicatorName, count) => {
        if (indicatorName.indexOf("->") > -1) {
          let sourceName = indicatorName.split(" -> ")[0];
          let sourceClassName = indicatorName.split(" -> ")[1];

          if (indicator === sourceName) {
            if (sources.indexOf(sourceClassName) < 0) {
              let mostRecentYearForSource = 0;
              sourceData[sourceClassName] = [];
              let indicatorIndex = indicatorNames.indexOf(indicatorName);
              data.slice(1).map((data, index) => {
                if (data[1] === state) {
                  if (typeof data[indicatorIndex] === "number") {
                    sourceData[sourceClassName].push([
                      parseInt(data[0]),
                      data[indicatorIndex],
                    ]);
                  }
                }
              });

              // console.log(sourceData, 'lsNdLgaData');

              //Filter sources without data
              if (sourceData[sourceClassName].length !== 0) {
                sourceObject[sourceClassName] = data[count];
                sourceClass.push(this.dataSourceClass[sourceClassName]);
                if (this.dataSourceClass[sourceClassName] === "Routine") {
                  routineCounter++;
                } else if (
                  this.dataSourceClass[sourceClassName] === "Surveys"
                ) {
                  surveyCounter++;
                } else {
                  estimatesCounter++;
                }
                sources.push(sourceClassName);
              }
            }
          }
        }
      });

      /**
       * The block below check to make sure IHME,NHMIS, and NDHS remian fixed
       * whether they have data or not
       */
      // if (sources.indexOf('IHME') < 0 && estimatesCounter == 0) {      //Remove IHME if there are other estimates

      // if (sources.indexOf("IHME") < 0 || estimatesCounter == 0) {
      //   //Always have IHME even if there are other estimates
      //   sources.push("IHME");
      //   estimatesCounter++;
      // }
      // if (sources.indexOf("NDHS") < 0 || surveyCounter == 0) {
      //   sources.push("NDHS");
      //   surveyCounter++;
      // }

      if (sources.indexOf("NHMIS-DHIS2") < 0) {
        sources.push("NHMIS-DHIS2");
      }

      //Sort sources and source class list based on the this.dataSourceClass arrangement
      sources.sort((a, b) => {
        return (
          Object.keys(this.dataSourceClass).indexOf(a) -
          Object.keys(this.dataSourceClass).indexOf(b)
        );
      });
      sourceClass.sort((a, b) => {
        return (
          Object.values(this.dataSourceClass).indexOf(a) -
          Object.values(this.dataSourceClass).indexOf(b)
        );
      });

      this.surveyCounter = surveyCounter;
      this.estimatesCounter = estimatesCounter;
      this.routineCounter = routineCounter;
      this.spanning = surveyCounter + estimatesCounter + routineCounter;

      sources.map((el, i) => {
        let obj = {
          name: el,
          uncertainty: false,
        };
        this.dataSourceUncertainty.push(obj);
      });
      this.dataSourceUncertainty.unshift({
        name: "NHMIS-DHIS2 (monthly)",
        uncertainty: false,
      });

      return [sourceClass, sources];
    },
    /**
     * This method gets the availble data for each source available for the selected indicator
     */
    getSourceData(indicator, source) {
      let data = this.appData.slice(0);
      let indicatorNames = data[0];
      let sourceData = {};

      source.map((elem, index) => {
        let mostRecentYearForSource = 0;
        sourceData[elem] = [];
        let indicatorSource = `${indicator} -> ${elem}`;
        let indicatorIndex = indicatorNames.indexOf(indicatorSource);
        data.slice(1).map((data, index) => {
          if (data[1] === this.selectedState) {
            if (typeof data[indicatorIndex] === "number") {
              sourceData[elem].push([parseInt(data[0]), data[indicatorIndex]]);
            }
          }
        });
      });
      return sourceData;
    },
    //Check display factor of selected indicator
    getDisplayFactor(indicator) {
      let displayFactor = "";

      for (const i in this.meta_data) {
        if (this.meta_data[i][0] === indicator) {
          displayFactor = this.meta_data[i][3];
          break;
        }
      }
      return displayFactor;
    },
    computeTableData(indicatorRelatives) {
      this.$store.state.CAR.compareSection.relatedIndicators =
        indicatorRelatives;
      let tableData = {};
      let tableData2 = [];
      this.displayFactor = [];
      indicatorRelatives.map((indicator, counter) => {
        let displayFactor = this.getDisplayFactor(indicator);
        this.displayFactor.push(displayFactor);
        var ivt =
          this.$store.state.CAR.indicatorAttributesOtherSources[indicator];
        let shortIndicatorName =
          this.$store.getters.getShortIndicatorNames(indicator);

        if (ivt) {
          var vt = ivt[1] === "P" ? "%" : "";
        }
        let data = this.getSourceData(indicator, this.availableSources);
        // console.log(this.availableSources, 'lsNdLgaData');

        tableData[shortIndicatorName] = [];
        if (counter === 0) {
          this.displayFactor.push("");
          tableData["Related Indicators"] = []; // Adds an empty row to the table
          tableData2[counter + 1] = [["Related Indicators"], []];
        }
        Object.keys(data).map((dataArray, count) => {
          if (data[dataArray].length > 0) {
            tableData[shortIndicatorName].push(`<label class='ind_value'>${
              data[dataArray][data[dataArray].length - 1][1].toFixed(1) + vt
            }<br/>
              <small style="font-size: 11px">${
                data[dataArray][data[dataArray].length - 1][0] || " "
              }</small>
            </label>`);
            if (counter == 0) {
              tableData2[counter] = [
                [shortIndicatorName],
                tableData[shortIndicatorName],
              ];
            } else {
              tableData2[counter + 1] = [
                [shortIndicatorName],
                tableData[shortIndicatorName],
              ];
            }
          } else {
            tableData[shortIndicatorName]
              .push(`<label class='ind_value'>${""}<br/>
              <small style="font-size: 11px">${" "}</small>
            </label>`);

            if (counter == 0) {
              tableData2[counter] = [
                [shortIndicatorName],
                tableData[shortIndicatorName],
              ];
            } else {
              tableData2[counter + 1] = [
                [shortIndicatorName],
                tableData[shortIndicatorName],
              ];
            }
          }
        });
      });
      // console.log(indicatorRelatives, 'indicatorRelatives');
      // console.log(tableData2, 'indicatorRelatives');
      this.$emit("indicatorRelatives", indicatorRelatives);

      this.indicatorRelativeValues = tableData2;
      //this.indicatorRelativeValues =this.indicatorRelativeValues.slice(1,4)

      this.indicatorRelativeValuese[0] = this.indicatorRelativeValues[0];
      this.indicatorRelativeValues = this.indicatorRelativeValues.slice(1, 4);
      let indicatorValuess = this.getNhmisMonthlyData(indicatorRelatives);

      if (this.indicatorRelativeValues[0] !== undefined) {
        // if (
        //   this.indicatorValuess !== undefined &&
        //   this.indicatorValuess[0].value !== undefined
        // ) {

        if (this.indicatorRelativeValuese[0][1] !== undefined) {
          if (indicatorValuess[0] !== undefined) {
            this.indicatorRelativeValuese[0][1]
              .unshift(`<label class='ind_value'>${
              indicatorValuess[0].value ? indicatorValuess[0].value + "%" : ""
            }<br/>
              <small style="font-size: 11px">${
                indicatorValuess[0].value ? indicatorValuess[0].date : ""
              }</small>
            </label>`);
          } else {
            this.indicatorRelativeValuese[0][1]
              .unshift(`<label class='ind_value'>${"-"}<br/>
              <small style="font-size: 11px">${"-"}</small>
            </label>`);
          }
        }

        // }
      }
      // 2ND TABLE ROW

      if (this.indicatorRelativeValues[1] !== undefined) {
        // if (
        //   this.indicatorValuess !== undefined &&
        //   this.indicatorValuess[1].value !== undefined
        // ) {
        if (indicatorValuess[1] !== undefined) {
          this.indicatorRelativeValues[1][1]
            .unshift(`<label class="ind_value">${
            indicatorValuess[1].value ? indicatorValuess[1].value + "%" : ""
          }<br/>
              <small style="font-size: 11px">${
                indicatorValuess[1].value ? indicatorValuess[1].date : ""
              }</small>
            </label>`);
          // }
        } else {
          this.indicatorRelativeValues[1][1]
            .unshift(`<label class='ind_value'>${"-"}<br/>
              <small style="font-size: 11px">${"-"}</small>
            </label>`);
        }
      }
      // 3RD TABLE ROW
      if (this.indicatorRelativeValues[2] !== undefined) {
        // if (
        //   this.indicatorValuess !== undefined &&
        //   this.indicatorValuess[2].value !== undefined
        // ) {
        if (indicatorValuess[2] !== undefined) {
          this.indicatorRelativeValues[2][1]
            .unshift(`<label class="ind_value">${
            indicatorValuess[2].value ? indicatorValuess[2].value + "%" : ""
          }<br/>
              <small style="font-size: 11px">${
                indicatorValuess[2].value ? indicatorValuess[2].date : ""
              }</small>
            </label>`);
          // }
        } else {
          this.indicatorRelativeValues[2][1]
            .unshift(`<label class='ind_value'>${"-"}<br/>
              <small style="font-size: 11px">${"-"}</small>
            </label>`);
        }
      }
      // if (this.routineCounter <= 1) {
      this.routineCounter = 2; // added 1 so that NHMIS monthly can be added under routine data on the table
      // }
      //console.log(this.indicatorRelativeValues)
    },
    // getNhmisMonthlyData(indicatorRelatives) {

    //   this.nhmisMonthlyData = this.$store.state.CAR.NhmisMonthlyData; // get NHMIS Monthly data from Store
    //   console.log(this.nhmisMonthlyData, 'nhmisMonthlyData wX');
    //   let indicatorValues = [];
    //   indicatorRelatives.forEach((element) => {
    //     let index = this.nhmisMonthlyData[0].indexOf(
    //       element + " -> " + "NHMIS-DHIS2"
    //     );
    //     let latestData = this.nhmisMonthlyData.slice(-36); // get the latest data for 36 states;
    //     let curentNationalData = latestData.filter(
    //       (val) => val[1] == this.selectedState
    //     ); // "this.selectedState"
    //     if (curentNationalData[0] !== undefined) {
    //       let curentNationalDataForIndicator = curentNationalData[0][index];
    //       // get the current date of the indicator value
    //       let currentDate = curentNationalData[0][0].split("T")[0];
    //       let dataDate = currentDate;
    //       indicatorValues.push({
    //         value: curentNationalDataForIndicator,
    //         date: dataDate,
    //       });
    //     }
    //   });
    //   console.log(indicatorValues, 'nhmisMonthlyData w');
    //   return indicatorValues;

    // },

    getNigeriaRow(data) {
      return data.find((row) =>
        row.some(
          (cell) =>
            typeof cell === "string" && cell.trim() === this.NhmisMonthlySelectedState
        )
      );
    },
    getNhmisMonthlyData(indicatorRelatives) {
      const nhmisMonthlyData = this.$store.state.CAR.NhmisMonthlyData; // Get NHMIS Monthly data from store
      // console.log(nhmisMonthlyData, "nhmisMonthlyData wX");

      if (!nhmisMonthlyData || nhmisMonthlyData.length === 0) {
        return []; // Return early if no data is available
      }

      const latestData = nhmisMonthlyData.slice(-36); // Get the latest data for 36 states
      // const stateData = latestData.find((val) => val[1] === this.selectedState); // Get data for the selected state
      // console.log(stateData, "stateData");
      const stateData = this.getNigeriaRow(latestData);

      if (!stateData) {
        return []; // Return early if no data for the selected state
      }

      const indicatorValues = indicatorRelatives
        .map((element) => {
          const index = nhmisMonthlyData[0].indexOf(
            `${element} -> NHMIS-DHIS2`
          );
          if (index === -1) {
            return null; // Skip if indicator is not found
          }

          const value = stateData[index];
          const date = stateData[0].split("T")[0]; // Extract the date

          return { value, date };
        })
        .filter(Boolean); // Remove null values

      return indicatorValues;
    },

    /**
     * Gets the short name for each indicator clicked and then runs this.dataSourceClicked() using the first data source
     * in this.availableSources array
     */
    viewMetadata(fieldVal) {
      let shortNames = this.$store.state.CAR.shortIndicatorNames;
      for (var i in shortNames) {
        if (shortNames[i] === fieldVal) this.indicatorMetaDataToShow = i;
      }

      this.isComponentModalActive = true;
      this.dataSourceClicked(this.availableSources[0]); // Computes meta data info for the first available source
    },
    dataSourceClicked(i) {
      this.computeMetaData();
      this.sourceIndicatorInfo = {};
      this.dataAvailable = {
        National: "grey",
        State: "grey",
        Senatorial: "grey",
        Zonal: "grey",
        LGA: "grey",
      };

      this.isActive = i;
      this.dataSourceName = i;

      var dataAvailable = this.indicatorInfo[i + " - dataAvailable"].replace(
        /\s/g,
        ""
      );
      var dataAvailable = dataAvailable.split(",");

      dataAvailable.map((elem) => {
        this.dataAvailable[elem] = "green"; //change the value in the gloabal dataAvailable object
      });

      this.sourceIndicatorInfo.name = this.indicatorInfo[i + " - name"];
      this.sourceIndicatorInfo.numerator =
        this.indicatorInfo[i + " - numerator"];
      this.sourceIndicatorInfo.denominator =
        this.indicatorInfo[i + " - denominator"];
      this.sourceIndicatorInfo.frequency =
        this.indicatorInfo[i + " - frequency"];
      this.sourceIndicatorInfo.definition =
        this.indicatorInfo[i + " - definition"];
      this.sourceIndicatorInfo.shortName = this.indicatorInfo["shortName"];
      this.sourceIndicatorInfo.multiplier =
        this.indicatorInfo["multiplierFactor"];
      this.sourceIndicatorInfo.type = this.indicatorInfo["type"];

      this.selectedDescription = this.$store.getters.getDataSourceDescriptions(
        this.dataSourceName
      );
      this.selectedTargetGroup = this.$store.getters.getTargetGroups(
        this.dataSourceName
      );
      this.selectedSampledHouseholdData =
        this.$store.getters.getSampledHouseholdData(this.dataSourceName);
    },
    //Determine the meta-data to use in the info modal
    computeMetaData() {
      this.indicatorInfo = [];
      this.indicatorMetaData.map((elem) => {
        if (this.indicatorMetaDataToShow === elem[1]) {
          this.indicatorInfo[elem[0] + " - name"] = elem[2];
          this.indicatorInfo[elem[0] + " - numerator"] = elem[3];
          this.indicatorInfo[elem[0] + " - denominator"] = elem[4];
          this.indicatorInfo[elem[0] + " - frequency"] = elem[5];
          this.indicatorInfo[elem[0] + " - definition"] = elem[7];
          this.indicatorInfo[elem[0] + " - dataAvailable"] = elem[8];
        }
      });
      this.meta_data.map((elem, index) => {
        if (this.indicatorMetaDataToShow == elem[0]) {
          this.indicatorInfo["shortName"] = elem[1];
          this.indicatorInfo["multiplierFactor"] = elem[2];
          this.indicatorInfo["type"] = elem[5];
        }
      });
    },
    viewSourceMetadata(theSource) {
      this.datasingle = theSource;
      this.datafull = this.sourceMetaData;
      //console.log(this.srcData);

      //   for (var i = 0; i < this.sourceMetaData.length; i++) {
      //     if (theSource == this.sourceMetaData[i][0]) {
      //       this.sourceInfo.name = this.sourceMetaData[i][0];
      //       this.sourceInfo.fullName = this.sourceMetaData[i][1];
      //       this.sourceInfo.description = this.sourceMetaData[i][2];
      //       this.sourceInfo.available = this.sourceMetaData[i][3];
      //       this.sourceInfo.nextAvailable = this.sourceMetaData[i][4];
      //       this.sourceInfo.links = this.sourceMetaData[i][5].replace(/\s+/g, '').split(',');
      //       // this.sourceInfo.links = this.sourceMetaData[i][5];
      //       this.sourceInfo.method = this.sourceMetaData[i][6];
      //       this.sourceInfo.subNatVal = this.sourceMetaData[i][7];
      //       // console.log(this.sourceMetaData[i][5]);

      //       var check1 = this.sourceMetaData[i][5];
      //       var check2 = check1.split(',');

      //       // console.log(check2);

      //       // var check3 = check2.split(' ');

      //       this.firstLink = check2;
      //       this.linkFirst = this.firstLink;
      //       // console.log(this.firstLink);

      //     }
      //   }

      this.isSourceMetaModalActive = true;
    },
    tableSourceClicked(source) {
      this.$store.dispatch("storeSourceClicked", source);
      // console.log(source);
      if (source !== "NHMIS-DHIS2") {
        this.showToggle = false;
      } else {
        this.showToggle = true;
      }
      eventBus.$emit("chartToggleEvent", this.showToggle);
      var yr;
      for (var item of this.ndOptionsArray) {
        //console.log(item.split(":"));
        let opt = item.split(":");
        if (opt[0] == source) {
          yr = opt[1];
          //console.log(yr);
        }
      }
      this.selectedSource = source;
      //this.selectedYear = yr;
      this.ndSelected = `${this.selectedSource}:${this.selectedYear}`;
      //this.ndSelectedOption();

      //Remove background color for other sources
      let tableSources = document.querySelectorAll(".table_sources");
      tableSources.forEach((sources, index) => {
        // if (sources.style.background === "rgb(39, 81, 80)") {
        sources.childNodes[2].style.background = "#41918e";
        sources.childNodes[2].style.fill = "#DDD";
        sources.style.background = "";
        sources.style.color = "#333";
        // }
      });

      //Add background and text color to selected source
      let tableSource = document.getElementById(source);
      let table = document.getElementById("source_table");

      if (tableSource.id === "NHMIS-DHIS2") {
        tableSource.childNodes[2].style.background = "#DDD";
        tableSource.childNodes[2].style.fill = "#41918e";
        tableSource.style.background = "rgb(54, 117, 116)";
        tableSource.style.color = "#FFF";
        table.rows[2].cells[2].style.background = "rgb(54, 117, 116)";
        table.rows[2].cells[2].style.borderBottomColor = "rgb(54, 117, 116)";
        table.rows[1].cells[2].style.borderBottomColor = "rgb(54, 117, 116)";
      } else {
        tableSource.childNodes[2].style.background = "#DDD";
        tableSource.childNodes[2].style.fill = "#41918e";
        tableSource.style.background = "#41918e";
        tableSource.style.color = "#FFF";
        table.rows[2].cells[2].style.background = "#41918e";
        table.rows[2].cells[2].style.borderBottomColor = "#DDD";
        table.rows[1].cells[2].style.borderBottomColor = "#DDD";
      }

      // ---FORMER CODE----///

      //Remove background color for other sources
      // let tableSources = document.querySelectorAll(".table_sources");
      // tableSources.forEach((sources, index) => {
      //   if (sources.style.background === "rgb(39, 81, 80)") {
      //     sources.childNodes[2].style.background = "#275150";
      //     sources.childNodes[2].style.fill = "#DDD";
      //     sources.style.background = "";
      //     sources.style.color = "#333";
      //   }
      // });

      //Add background and text color to selected source
      // let tableSource = document.getElementById(source);
      // tableSource.childNodes[2].style.background = "#DDD";
      // tableSource.childNodes[2].style.fill = "#275150";
      // tableSource.style.background = "#275150";
      // tableSource.style.color = "#FFF";

      // ---FORMER CODE END-----////
    },
    confirmUncertaintyData() {
      this.isUncertaintyAvailable = {};
      // var data = this.estimatesData.slice(0);
      var data = this.uncertaintyData.slice(0);
      this.sourceList.map((source, index) => {
        let indicatorWithSource = this.selectedIndicator + " -> " + source;
        let indicatorNameArray = data[0];
        let indexOfIndicator = indicatorNameArray.indexOf(indicatorWithSource);
        if (indexOfIndicator > -1) {
          this.isUncertaintyAvailable[source] = true;
        }
      });
    },
    plotUncertainty(truthVal, source, index) {
      this.dataSourceUncertainty[index].uncertainty =
        !this.dataSourceUncertainty[index].uncertainty;
      this.$emit("toggleClicked", [
        this.dataSourceUncertainty[index].uncertainty,
        source,
      ]);
    },
    handleScroll() {
      const mq = window.matchMedia("(max-width: 700px)");
      if (mq.matches) {
        if (
          document.body.scrollTop > 300 ||
          document.documentElement.scrollTop > 300
        ) {
          document.getElementById("scrollLeft").style.display = "none";
          document.getElementById("scrollRight").style.display = "none";
        } else {
          document.getElementById("scrollRight").style.display = "block";
        }
      }
    },
    getIndicators() {
      var programAreasToIndicators =
        this.$store.state.CAR.programAreasToIndicators;
      var options = [],
        temp = {};
      Object.keys(programAreasToIndicators).map((elem, index) => {
        temp.programArea = elem;
        temp.indicators = [];
        var tempName = {};
        programAreasToIndicators[elem].forEach((element) => {
          temp.indicators.push({
            name: element,
          });
        });
        options.push(temp);
        temp = {};
      });
      // this.options = options;
      this.optionIndicators = options;
    },
    multiselectSearch() {
      this.collapsible = false;
    },
    openedMultiselect() {
      //this.multiselectPlaceholder = 'Search Indicator';
      this.collapsible = true;
    },
    closedMultiselect(e, index) {
      this.multiselectPlaceholder[index] = e;

      this.collapsible = true;
    },
    multiselectPlaceholderM(e) {
      if (e >= 0) {
        let placeholder = this.selectIndicatorRelative[e].name;
        return placeholder;
      }
    },
    getDS() {
      const result = [];
      const DSMeta = JSON.parse(this.$ls.get("source_meta_dataset"));
      const DSMeta2 = DSMeta.slice(1);
      DSMeta2.map((el) => {
        result.push([`${el[0]} : ${el[1]}`]);
      });
      // get the sourcelist data
      const ds = DSMeta2.map((el) => el[0]);
      this.sourceList = ds;

      // get the datasource fullnames data
      const dsFullNames = result.map((el) => {
        return el
          .map((keyVal) => {
            return keyVal.split(":").map((_) => _.trim());
          })
          .reduce((accumulator, currentValue) => {
            accumulator[currentValue[0]] = currentValue[1];
            return accumulator;
          }, {});
      });

      this.sourceFullName = Object.assign({}, ...dsFullNames);

      // get classifications
      const results = [];
      DSMeta2.map((el) => {
        results.push([`${el[0]} : ${el[8]}`]);
      });

      const reOrderedDs = results.filter((el) => {
        if (el[0].split(":")[0].trim() !== "NHMIS-DHIS2") {
          return el;
        }
      });
      reOrderedDs.unshift(["NHMIS-DHIS2 : Routine"]);

      const dsClassification = reOrderedDs.map((el) => {
        return el
          .map((keyVal) => {
            return keyVal.split(":").map((_) => _.trim());
          })
          .reduce((accumulator, currentValue) => {
            accumulator[currentValue[0]] = currentValue[1];
            return accumulator;
          }, {});
      });

      this.dataSourceClass = Object.assign({}, ...dsClassification);
    },
  },
  updated() {},
  computed: {
    /**
     * Sets the selected indicator based on the value gotten from car.js
     * and gets the short name for the selected indicator
     */
    indicatorSelected() {
      this.selectedIndicator = this.$store.getters.getSelectedIndicator;
      var temp = this.$store.getters.getShortIndicatorNames(
        this.selectedIndicator
      );
      return str_limit(temp, 80);
    },
    // Return the selected state from the store
    stateSelected() {
      this.selectedState = this.$store.getters.getSelectedState;
      return this.selectedState;
    },
  },
  async mounted() {
    // this.getDS()
    // eventBus.$on("selectedYear", (data) => {
    //   this.selectedYear = data
    //   this.ndSelectedOption();
    // })
    // eventBus.$on("computeNd", data => {
    //   this.selectedYear = data;
    //   //console.log(data)
    //   this.ndSelected = `${this.selectedSource}:${data}`;
    //   this.ndSelectedOption();
    //   //console.log(this.selectedYear);
    // });
    this.selectedSource = "NHMIS-DHIS2";
    //console.log(this.indicatorMetaData)
    // this.selectedSource = "NHMIS"
    //  this.selectedIndicator = "Skilled attendance at delivery or birth"
    //  this.selectedState = "National"
    // await this.getDS();
    this.lsNdStateData = await this.getIdb();
    this.lsNdLgaData = JSON.parse(this.$ls.get("nd_lga_data"));

    //console.log(this.lsNdLgaData)
    this.ndSelectedOption();
    //eventbus from columnchart.vue
    eventBus.$on("ndOptionsEvent", (data) => {
      this.ndOptions = data;
      //maps through ndOptions and returns source:year
      this.ndOptionsArray = this.ndOptions.map((val) => {
        return val.years[0].name;
      });
      //console.log(this.ndOptionsArray);
    });

    /*listen to SelectedSource been fired from barChartComponent*/
    eventBus.$on("barSourceEvent", (data) => {
      // this.tableSourceClicked(data);
      // if (data == 'NHMIS') this.showToggle = true
      // else this.showToggle = false
      this.$store.dispatch("storeSourceClicked", data);
    });

    if (this.appData) {
      this.sourceClass = this.getAvailbleSourcesByIndicator(
        this.selectedIndicator,
        this.selectedState
      )[0];
      this.availableSources = this.getAvailbleSourcesByIndicator(
        this.selectedIndicator,
        this.selectedState
      )[1];
      this.indicatorRelativesObject =
        this.$store.state.CAR.indicatorsAndRelative;
      let indicatorRelatives = Object.assign(
        [],
        this.indicatorRelativesObject[this.selectedIndicator]
      );
      indicatorRelatives.unshift(this.selectedIndicator);
      this.computeTableData(indicatorRelatives);
      this.confirmUncertaintyData();
      this.$store.dispatch("storeSourceClicked", this.availableSources);
      this.$store.dispatch("storeMultipleSourceData", {
        list: this.lsData,
      });
      this.getIndicators();
    }

    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  watch: {
    selectedIndicator56(val) {
      this.selectedIndicator = this.ndSelectedOption();
      this.ndSelectedOption();
    },
    selectedYear(val) {
      if (val == undefined || val == "2021") {
        this.numerator = "Unavailable";
        this.denominator = "Unavailable";
        this.numValue = "";
        this.denValue = "";
      }

      //this.ndSelectedOption();
      this.ndSelected = `${this.selectedSource}` + ":" + val;
      // this.ndSelectedOption();
    },

    ndSelected(val) {
      //console.log(val);
      this.ndYear = val.split(":");
      //console.log(this.ndYear);

      this.selectedYear = this.ndYear[1];
      this.selectedSource = this.ndYear[0];
      this.selectedIndicator = this.$store.getters.getSelectedIndicator;
      // this.tableSourceClicked(this.selectedSource);
      this.ndSelectedOption();
    },
    selectedSource(val) {
      this.ndSelectedOption();
      //this.ndSelected = `${val}:${this.selectedYear}`;
    },

    async selectedIndicator(val) {
      // await this.getDS();
      this.ndSelectedOption();
      if (this.appData) {
        this.sourceClass = this.getAvailbleSourcesByIndicator(
          val,
          this.selectedState
        )[0];
        this.availableSources = this.getAvailbleSourcesByIndicator(
          val,
          this.selectedState
        )[1];
        this.$store.dispatch("storeSourceClicked", this.availableSources);
        this.indicatorRelativesObject =
          this.$store.state.CAR.indicatorsAndRelative;
        let indicatorRelatives = [];
        indicatorRelatives = Object.assign(
          [],
          this.indicatorRelativesObject[val]
        );
        indicatorRelatives.unshift(val);

        this.computeTableData(indicatorRelatives);
        // Change multiselect v-model
        this.selectIndicatorRelative = [];
        indicatorRelatives.map((el, i) => {
          if (i > 0) {
            this.selectIndicatorRelative.push({
              name: el,
            });
          }
        });
        this.ndSelectedOption();
        this.confirmUncertaintyData();
      }
      //Remove background color for all sources
      let tableSources = document.querySelectorAll(".table_sources");
      tableSources.forEach((sources, index) => {
        if (sources.style.background === "rgb(65, 145, 142)") {
          sources.childNodes[2].style.background = "#41918E";
          sources.childNodes[2].style.fill = "#DDD";
          sources.style.background = "";
          sources.style.color = "#333";
        }
      });
      this.showToggle = false;
    },

    selectIndicatorRelative(name) {
      let indicatorRelatives = [];
      name.map((relative, index) => {
        indicatorRelatives.push(relative.name);
      });
      indicatorRelatives.unshift(this.selectedIndicator);
      // console.log(indicatorRelatives);
      this.computeTableData(indicatorRelatives);
    },
    uncertaintyData(val) {
      // this.estimatesData = val;
      this.uncertaintyData = val;
    },
    meta_data(val) {
      this.meta_data = val;
    },
    sourceMetaData(val) {
      this.sourceMetaData = val;
    },
    appData(val) {
      if (val) {
        this.lsData = val;
        this.sourceClass = this.getAvailbleSourcesByIndicator(
          this.selectedIndicator,
          this.selectedState
        )[0];
        this.availableSources = this.getAvailbleSourcesByIndicator(
          this.selectedIndicator,
          this.selectedState
        )[1];
        this.indicatorRelativesObject =
          this.$store.state.CAR.indicatorsAndRelative;
        let indicatorRelatives = Object.assign(
          [],
          this.indicatorRelativesObject[this.selectedIndicator]
        );
        indicatorRelatives.unshift(this.selectedIndicator);
        this.computeTableData(indicatorRelatives);
        this.confirmUncertaintyData();
        this.$store.dispatch("storeSourceClicked", this.availableSources);
        this.$store.dispatch("storeMultipleSourceData", {
          list: this.lsData,
        });
        this.getIndicators();
      }
      this.ndSelectedOption();
    },
    selectedState(val) {
      if (this.appData) {
        this.sourceClass = this.getAvailbleSourcesByIndicator(
          this.selectedIndicator,
          val
        )[0];
        this.availableSources = this.getAvailbleSourcesByIndicator(
          this.selectedIndicator,
          val
        )[1];
        this.indicatorRelativesObject =
          this.$store.state.CAR.indicatorsAndRelative;
        let indicatorRelatives = [];
        indicatorRelatives = Object.assign(
          [],
          this.indicatorRelativesObject[this.selectedIndicator]
        );
        indicatorRelatives.unshift(this.selectedIndicator);

        this.computeTableData(indicatorRelatives);
        this.ndSelectedOption();
      }
      this.ndSelectedOption();
    },
  },
};
</script>

<style scoped>
.color-head {
  border-bottom-color: #275150 !important;
}

.color-light {
  border-bottom-color: #41918e !important;
}
.border_top {
  border-bottom-color: #275150 !important;
}

.table_sources:hover svg {
  background: #fff !important;
  fill: #41918e !important;
}
</style>



// WEBPACK FOOTER //
// tableComponent.vue?0da087ea